export default __webpack_public_path__ + "static/media/weather.8f60c6cd.png";